export enum GenDelegoTransactionStatus {
    SUCCESS = 'SUCCESFULL'
}
